import { render, staticRenderFns } from "./ActivtyTask.vue?vue&type=template&id=99fd40a4"
import script from "./ActivtyTask.vue?vue&type=script&lang=js"
export * from "./ActivtyTask.vue?vue&type=script&lang=js"
import style0 from "./ActivtyTask.vue?vue&type=style&index=0&id=99fd40a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports